import { render, staticRenderFns } from "./QuestionAnswerDetailsTable.vue?vue&type=template&id=59f36861&lang=pug"
import script from "./QuestionAnswerDetailsTable.vue?vue&type=script&lang=ts"
export * from "./QuestionAnswerDetailsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports